import React, { useState, useContext, createContext, useEffect } from "react";

// ** Utils Imports

const mapRegionSelectContext = createContext();

export function ProviderRegionSelect({ children }) {
  const regionSelect = useProviderMapRegionSelect();
  return (
    <mapRegionSelectContext.Provider value={regionSelect}>
      {children}
    </mapRegionSelectContext.Provider>
  );
}

export const useMapRegionSelect = () => {
  return useContext(mapRegionSelectContext);
};

function useProviderMapRegionSelect() {
  // ** State
  const [isOpenMapRegionSelect, setIsOpenMapRegionSelect] = useState(false);
  const [mapLatlong, setMapLatlong] = useState({ lat: 59.95, lng: 30.33 });

  useEffect(() => {
    
  
    return () => {
      
    }
  }, [])
  

  // Return State && SetState
  return {
    isOpenMapRegionSelect,
    mapLatlong,
    setMapLatlong,
    setIsOpenMapRegionSelect
  };
}
